module.exports = __webpack_public_path__ + "img/gh____-13.prt.abd2172d.jpg";